/**
 * Sync native GTranslate widget with a custom selection display.
 * Uses the original .glink anchors directly — no extra markup is created.
 */
function hideGTranslateArtifacts() {
  document.querySelectorAll("iframe.goog-te-banner-frame, iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd").forEach((frame) => {
    frame.style.display = "none";
    frame.style.visibility = "hidden";
  });

  document
    .querySelectorAll(
      ".goog-te-spinner-pos, .goog-logo-link, #goog-gt-tt, .VIpgJd-ZVi9od-aZ2wEe, .VIpgJd-ZVi9od-ORHb-OEVmcd, .VIpgJd-ZVi9od-aZ2wEe-wOHMyf"
    )
    .forEach((element) => {
      element.style.display = "none";
      element.style.visibility = "hidden";
    });

  if (document.body.classList.contains("translated-ltr") || document.body.classList.contains("translated-rtl")) {
    document.body.style.top = "0";
  }
}

function syncGTranslate() {
  document.querySelectorAll(".gtranslate-wrapper-outside").forEach((container) => {
    const wrapper = container.querySelector(".gtranslate_wrapper");
    if (!wrapper) return;

    const links = wrapper.querySelectorAll("a.glink[data-gt-lang]");
    if (!links.length) return;

    // Sync current-language text into .selection
    const selectionSpan = container.querySelector(".gtranslate-selection .selection");
    const currentLink = wrapper.querySelector("a.glink.gt-current-lang");
    if (selectionSpan && currentLink) {
      selectionSpan.textContent = currentLink.textContent.trim();
    }

    // One-time event binding
    if (container.dataset.gtBound) return;
    container.dataset.gtBound = "1";

    // Toggle dropdown on selection click
    const selection = container.querySelector(".gtranslate-selection");
    if (selection) {
      selection.addEventListener("click", (e) => {
        // Ignore clicks on actual .glink anchors
        if (e.target.closest("a.glink")) return;
        container.classList.toggle("gt_open");
      });
    }

    wrapper.addEventListener("click", (e) => {
      const link = e.target.closest("a.glink[data-gt-lang]");
      if (!link) return;

      e.preventDefault();
      e.stopPropagation();

      const lang = link.dataset.gtLang;
      if (!lang) return;

      wrapper.querySelectorAll("a.glink.gt-current-lang").forEach((item) => {
        item.classList.remove("gt-current-lang");
      });
      link.classList.add("gt-current-lang");

      if (selectionSpan) {
        selectionSpan.textContent = link.textContent.trim();
      }

      if (typeof window.doGTranslate === "function") {
        window.doGTranslate(`auto|${lang}`);
      }

      container.classList.remove("gt_open");
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) {
        container.classList.remove("gt_open");
      }
    });
  });
}

/**
 * Watch for GTranslate widget injection / active-language changes.
 */
export function watchGTranslate() {
  syncGTranslate();
  hideGTranslateArtifacts();

  let frameId = null;
  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => {
      if (mutation.type === "childList") {
        return mutation.addedNodes.length || mutation.removedNodes.length;
      }

      if (mutation.type === "attributes") {
        const target = mutation.target;
        return target instanceof Element && target.matches(".gtranslate_wrapper, .gtranslate_wrapper *");
      }

      return false;
    });

    if (!shouldSync || frameId !== null) return;

    frameId = window.requestAnimationFrame(() => {
      frameId = null;
      syncGTranslate();
      hideGTranslateArtifacts();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
}
